import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $, { get } from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';

const ConfirmationModal = (props) => {
    const handleClick = (flag) => {
        props.onConfirmation(flag);
    };

    const btnName = (props.message.buttonName || "").toLowerCase();

    // Determine icon and color based on button name
    let topIcon = "bi bi-info-circle";
    let iconBgColor = "#15b899";

    if (btnName.includes("download") || btnName.includes("view")) {
        topIcon = btnName.includes("download") ? "bi bi-cloud-arrow-down-fill" : "bi bi-eye-fill";
        iconBgColor = "#15b899";
    } else if (btnName.includes("delete") || btnName.includes("remove")) {
        topIcon = "bi bi-trash-fill";
        iconBgColor = "#dc3545"; // danger
    } else if (btnName.includes("approve") || btnName.includes("save") || btnName.includes("submit")) {
        topIcon = "bi bi-check-circle-fill";
        iconBgColor = "#15b899"; // Match btn-aqua theme
    } else if (btnName.includes("logout")) {
        topIcon = "bi bi-box-arrow-right";
        iconBgColor = "#ffc107"; // warning
    }

    return (
        <Modal isOpen={true}>
            {/* Compact: at most 400px wide (it stretched across most of the screen),
                full width less 16px a side on phones */}
            <div className="modal-dialog modal-dialog-centered confirm-dialog">
                <div className="modal-content shadow-lg border-0" style={{ backgroundColor: '#ffffff', borderRadius: '14px', padding: '18px 20px 20px', opacity: 1 }}>
                    <div className="text-end mb-0">
                        <button type="button" className="btn-close rounded-circle p-2" style={{ fontSize: '9px', backgroundColor: '#f1f5f9', opacity: 1 }} onClick={() => handleClick(0)}></button>
                    </div>

                    <div className="text-center mb-3">
                        <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2" style={{ backgroundColor: `${iconBgColor}1A`, width: '64px', height: '64px', position: 'relative' }}>
                            <div className="d-inline-flex align-items-center justify-content-center rounded-circle text-white shadow-sm" style={{ backgroundColor: iconBgColor, width: '40px', height: '40px', fontSize: '20px', zIndex: 2 }}>
                                <i className={topIcon}></i>
                            </div>
                        </div>
                        <h4 className="fw-bold text-dark mb-1" style={{ fontSize: '17px' }}>{props.message.message}</h4>
                        <p className="text-muted mb-0 text-center" style={{ fontSize: '13px' }}>Please confirm if you want to proceed with this action.</p>
                    </div>

                    <div className="d-flex flex-row justify-content-center gap-3">
                        <button
                            type="button"
                            className={`btn fw-semibold py-2 w-50 ${iconBgColor === '#dc3545' ? 'btn-danger text-white' : iconBgColor === '#ffc107' ? 'btn-warning text-dark' : 'btn-aqua'}`}
                            // style={{ borderRadius: '8px', border: 'none', fontSize: '15px' }}
                            onClick={() => handleClick(1)}
                        >
                            {/* <i className={`${topIcon} me-2`} style={{ fontSize: '14px' }}></i> */}
                            {props.message.buttonName}
                        </button>
                        <button
                            type="button"
                            className="btn btn-gray fw-semibold py-2 w-50"
                            // style={{ borderRadius: '8px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', color: '#495057', fontSize: '15px' }}
                            onClick={() => handleClick(0)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ConfirmationModal;